(function () {
  function initGrid(grid) {
    if (grid.dataset.megaMenuHoverInit) return;
    grid.dataset.megaMenuHoverInit = 'true';

    var cards = Array.from(grid.querySelectorAll('[data-feature-for]'));
    if (cards.length === 0) return;

    var hideTimer = null;

    function showCard(url) {
      if (hideTimer) {
        clearTimeout(hideTimer);
        hideTimer = null;
      }
      cards.forEach(function (c) { c.classList.remove('is-active'); });
      var match = cards.find(function (c) {
        return c.getAttribute('data-feature-for') === url;
      });
      if (match) match.classList.add('is-active');
    }

    function hideAll() {
      hideTimer = setTimeout(function () {
        cards.forEach(function (c) { c.classList.remove('is-active'); });
      }, 100);
    }

    grid.querySelectorAll('[data-col-url]').forEach(function (col) {
      col.addEventListener('pointerenter', function () {
        showCard(col.getAttribute('data-col-url'));
      });
    });

    grid.addEventListener('pointerleave', hideAll);
  }

  function init() {
    document.querySelectorAll('.mega-menu__grid').forEach(initGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
